import React from 'react';
import BookFlightOptions from "./BookFlightOptions/BookFlightOptions";
import styles from '../SearchWidget.module.scss';
import FlightLegs from "./FlightLegs/FlightLegs";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import LoginForm from "../LoginForm/LoginForm";
import responsiveDefinitions from "../../../hoc/ResponsiveDefinitions/ResponsiveDefinitions";

const BookFlight = ({userCardType, imagineMode, Styles}) => {

    const bookJsx = imagineMode && !userCardType ? <LoginForm/> : <FlightLegs/>;

    const isDesktop = Styles.matches(false, false);

    return (
        <div className={styles.bookFlightContainer}>
            {bookJsx}
            <BookFlightOptions display={isDesktop} classes={'sw-hidden-on-shrink'}/>
        </div>
    );
};


BookFlight.propTypes = {
    Styles: PropTypes.object,
    userCardType: PropTypes.string,
    imagineMode: PropTypes.bool,
};

BookFlight.defaultProps = {
    Styles: {},
    userCardType: '',
    imagineMode: false,
};

export default responsiveDefinitions(connect(state => ({userCardType: state.common.userCardType, imagineMode: state.flightCourse.imagineMode}))(BookFlight));
